// @flow
import client from '../../client'
import format from '../../utils/format'

// API Endpoinds
export const UPLOAD_IMAGE_ENDPOINT = '/data-entry/providers/{0}/upload_logo/'

/**
 * Returns a new logo
 * @param {Object} data Provider data
 * @param {string} data.id Provider ID
 * @param {FormData} data.image Image data
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const uploadImage = (data: {
  id: string,
  image: FormData,
}): Promise<any> => {
  const endpoint = format(UPLOAD_IMAGE_ENDPOINT, data.id)

  return client.put(endpoint, {
    body: data.image,
  })
}

export default uploadImage
